import * as actionTypes from "./actionTypes";
import * as types from "./types";

//Extractor Job Schedules 
export const postWorkFlowsRequest = (payload: types.IWorkflowParams): types.PostWorkflowRequest => ({
    type: actionTypes.POST_WORKFLOW_REQUEST,
    payload
});

export const postWorkFlowsSuccess = (payload: types.IPostWorkflowSuccessPayload): types.PostWorkflowSuccess => ({
    type: actionTypes.POST_WORKFLOW_SUCCESS,
    payload
});

export const postWorkFlowsFailure = (payload: types.IPostWorkflowFailurePayload): types.PostWorkflowFailure => ({
    type: actionTypes.POST_WORKFLOW_FAILURE,
    payload
});